export default __webpack_public_path__ + "static/media/home-interactive-portfolio-img-03.8875450d.jpg";